import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import StorageUtils from '@spothero/utils/storage';

export default function trackFacilityDetailsPage(args) {
    try {
        const {
            spot: {
                currency_type,
                facility,
                spotId,
                title,
                rating_info,
                selectedRate,
            },
        } = args;

        const properties = {
            partner_affiliate:
                StorageUtils.get('sh-partner-affiliate', 'session') || null,
            currency: currency_type,
            parking_type: 'transient', // Eventually, if this page supports more verticals, will need to adjust this
            city: facility.city,
            state: facility.state,
            operator_id: facility.operator_id,
            parking_spot_id: spotId,
            parking_spot_name: title,
            star_rating: rating_info?.star_rating,
            amenities: selectedRate?.amenities?.map(({name}) => name) || [],
            free_cancellation: facility.cancellation_allowed !== 'no',
        };

        SegmentUtils.page({
            name: 'Facility Details',
            properties,
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage:
                'Segment Page Failed - trackFacilityDetailsPage',
        });
    }
}
